import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import JSEncrypt from "jsencrypt/bin/jsencrypt.min.js";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/scss/index.scss";
import "@/utils/Router.js";
import "@/utils/http";
import "@/utils/vueScroll.js";
import { deepCopy, initFormData, commPropCopy } from "./utils/datatransfer.js";
import "@/assets/images/iconfont/iconfont.css";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css';
Vue.prototype.$deepCopy = deepCopy;
Vue.prototype.$initFormData = initFormData;
Vue.prototype.$commPropCopy = commPropCopy;

Vue.use(ElementUI);
Vue.prototype.$jsencrypt = JSEncrypt;
Vue.config.productionTip = false;
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    //隐藏不需要的工具栏
    navbar:false,
    toolbar:false,
    button:false,
    url(image) {
      //修改图片放大时的图片路径，这里_300是我缩略图和大图的区别
      return image.src.replace('_300', '');
    },
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
